export default "__VITE_ASSET__Vma6dtXl__"